'use client'

import { createContext, useContext, useEffect, useState, ReactNode } from 'react'
import { getMe, logout as apiLogout, PayloadUser } from './auth'
import { useRouter } from 'next/navigation'

interface AuthContextType {
  user: PayloadUser | null
  loading: boolean
  logout: () => Promise<void>
  refresh: () => Promise<void>
}

const AuthContext = createContext<AuthContextType | null>(null)

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser]     = useState<PayloadUser | null>(null)
  const [loading, setLoading] = useState(true)
  const router = useRouter()

  const refresh = async () => {
    const me = await getMe()
    setUser(me)
  }

  useEffect(() => {
    refresh().finally(() => setLoading(false))
  }, [])

  const logout = async () => {
    await apiLogout()
    setUser(null)
    router.push('/login')
  }

  return (
    <AuthContext.Provider value={{ user, loading, logout, refresh }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuth() {
  const ctx = useContext(AuthContext)
  if (!ctx) throw new Error('useAuth must be used within AuthProvider')
  return ctx
}